import {
  acceptOnlyFilterdKeys,
  basePathRewrite,
  closeFJDifferentModal,
  commonPropsForSSR,
  ensureVisitorId,
  getAbsoluteURL,
  getEJendPoints,
  getJobIndex,
  getURLSearchParams,
  localStorageGetItem,
  localStorageSetItem,
  makeFlexJobsWizardBoolean,
  modifyJobFilters,
  readCookie,
} from '@components/common';
import {
  _CONSTANTS,
  CategoriesList,
  remoteJobsList,
} from '@components/common/constant';
import { jobSearchResultTrackEvent } from '@components/common/event-tracker';
import {
  getFilterQueryString,
  mapQueryParams,
} from '@components/common/filterHelper';
import FlexJobDifferModal from '@components/companies/unAuthPopup';
import { RemoteCategoriesMetaTags } from '@components/metaComponent/remoteCategories';
import SearchListingContainer from '@components/searchListContainer';
import { cdnEXPTType, IDeviceType, IJobCount } from '@components/shared.types';
import {
  JobSearchSteps,
  RemoteJobsPage,
  useDeviceType,
  useLandingPageTracking,
} from '@license-admin/boldjobs';
import { fireExperimentEvent } from '@utils/cdnTracking';
import jobSearchStepsProps from '@utils/jobSearchStepsProps';
import softRegModalProps from '@utils/softRegModalProps';
import { getJobDetailsV2 } from 'API/ApiHelpers';
import {
  getJobDetailsApiUrl,
  getLocalizationAndConfig,
  modifyJobDetails,
} from 'API/jobs';
import { apiCallList } from 'API/wlb/ApiClient';
import { getFreeJobsByCategory } from 'API/wlb/jobs';
import { blob_img_path, getENVPath } from 'helper';
import {
  getGuidValue,
  getOrUpdateGUID,
  getSearchType,
} from 'helper/eventTrackingUtils';
import { SearchType, ViewType } from 'helper/eventTrackingUtils/constant';
import {
  ConductExperimentV3,
  getCDNExptDetails,
  getExperimentVariant,
  getUserExperimentVaient,
} from 'helper/experiments/experimentActions';
import {
  CDN_EXPERIMENT_DETAILS,
  RMCPortalExperiments,
} from 'helper/experiments/experimentConstants';
import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { useCallback, useEffect, useMemo, useState } from 'react';

type IProps = {
  localization: any;
  isPremiumUser: boolean;
  deviceType: IDeviceType;
  themeType?: string;
  selectedFilters: { [key: string]: Array<string> };
  categorizedJobs: any;
  jobCardData: any;
  queryParams: any;
  config: any;
  isLoggedIn: boolean;
  isFromWizardPage: boolean;
  hiring_count: IJobCount;
  breadCrumbProps: {
    breadCrumbName: string;
    breadCrumbNameValue: string[];
    isRemoteJobsPage: boolean;
    breadCrumbsData: {
      page: string;
      title: string;
      children: {
        name: string;
        path: string;
        static: boolean;
      }[];
    };
  };
  cdnExptData?: cdnEXPTType;
  referer: string;
  isSearchPage?: boolean;
  cookies?: any;
  localizationWhyRMCJobs?: any;
  jobDetailsApiUrl?: any;
  userAgent: string;
  cookieHeader?: string;
  expBrowsingCategoryDetailsVariant?: string;
  showAllDropFilters?: boolean;
  schemaDateModified?: string;
  userInteractExpId?: any;
};

export default function WhiteLabelRJobs(props: IProps) {
  const {
    config,
    localization,
    themeType,
    jobCardData,
    isLoggedIn,
    isFromWizardPage,
    localizationWhyRMCJobs,
    jobDetailsApiUrl,
    userAgent,
    queryParams,
    isPremiumUser,
    deviceType,
    cookieHeader,
    expBrowsingCategoryDetailsVariant,
    userInteractExpId,
  } = props;
  const [showFlexJobsDifferent, setShowFlexJobsDifferent] = useState(false);
  const [isSoftRegModal, setIsSoftRegModal] = useState(false);
  const [isAddStaticSearchList, setAddStaticSearchList] =
    useState<boolean>(false);
  const [isSoftRegAlreadyShown, setIsSoftRegAlreadyShown] = useState(
    !!readCookie('softRegPopupDisplayed')
  );
  //exp browsing_CategoryHub
  const [browsingCategoryVariant] = useState<string>(
    expBrowsingCategoryDetailsVariant || ''
  );

  useEffect(() => {
    const isBrowsingCategoryVariant: any =
      browsingCategoryVariant === '3' || browsingCategoryVariant === '4';
    if (isBrowsingCategoryVariant) {
      const hasVisitedBefore = localStorageGetItem(
        'browsing-experience-visited'
      );
      if (hasVisitedBefore) {
        localStorageSetItem('browsing-experience-visited', 'true');
      } else {
        localStorageSetItem('browsing-experience-visited', 'false');
      }
    }
  }, [browsingCategoryVariant]);
  //exp browsing_CategoryHub ends

  // const [isUserInteractiveJobVariant, setUserInteractiveJobVariant] =
  //   useState<number>(0);
  // const [shouldShowDrawer, setShouldShowDrawer] = useState(!isLoggedIn);
  const isMobileView = useDeviceType(props.deviceType) === 'mobile';

  // Baseline variant assignment for user interaction experiment:
  // Mobile devices are assigned variant 3 and desktop devices variant 0,
  // as determined by the RMCPortalExperiments.rmcUserInteractionMobile experiment.
  const isUserInteractiveJobVariant = isMobileView ? 3 : 0;

  let softRegPopupTimout: any = null;
  useEffect(() => {
    if (isFromWizardPage) {
      clearTimeout(softRegPopupTimout);
      softRegPopupTimout = setTimeout(() => {
        setIsSoftRegModal(true);
      }, 4000);
    }

    setShowFlexJobsDifferent(
      makeFlexJobsWizardBoolean(
        props.referer,
        props.isPremiumUser,
        props.isSearchPage
      )
    );
  }, []);

  const breadCrumbProps = {
    breadCrumbName: `${
      props.isPremiumUser ? 'rmc-remote-jobs-auth' : 'rmc-remote-jobs-unauth'
    }`,
    breadCrumbNameValue: [''],
    isRemoteJobsPage: true,
    breadCrumbsData: [
      {
        page: 'rmc-remote-jobs-auth',
        title: 'Remote Jobs - No Ads, Scams, or Junk',
        children: [
          {
            name: 'My Dashboard',
            path: '/dashboard',
            static: false,
            rel: 'nofollow',
          },
          {
            name: 'Remote Jobs',
            path: '/remote-jobs',
            static: false,
          },
        ],
      },
      {
        page: 'rmc-remote-jobs-unauth',
        title: 'Remote Jobs - No Ads, Scams, or Junk',
        children: [
          {
            name: 'Home',
            path: '/',
            static: false,
          },
          {
            name: 'Remote Jobs',
            path: '/remote-jobs',
            static: false,
          },
        ],
      },
    ],
  };
  const isDesktopView = useDeviceType(props.deviceType) === 'desktop';

  const [isExpSavedSearchVariant, setSavedSearchDropDownVariant] =
    useState(false);

  const runPremiumExperiment = async () => {
    try {
      let userStatus = readCookie(_CONSTANTS.USER_STATUS);
      const userId = userStatus ? JSON.parse(userStatus)?.User?.UserId : null;
      if (userId) {
        const experimentID = isDesktopView
          ? RMCPortalExperiments.rmcSearchDropdownDesktopRC1.id
          : RMCPortalExperiments.rmcSearchDropdownMobileRC1.id;
        const exptData = await getUserExperimentVaient(
          userId,
          experimentID,
          cookieHeader
        );
        if (exptData === 3) {
          setSavedSearchDropDownVariant(true);
        }
      }
    } catch (error) {
      console.error('Premium experiment conduction error:', error);
    }
  };

  const runVisitorExperiment = async () => {
    try {
      const visitorId = await ensureVisitorId(20, 1000);

      if (visitorId) {
        const expVariant = getExperimentVariant(
          RMCPortalExperiments.rmcSearchDropdownMobile.id
        );
        if (Number(expVariant) === 3) {
          setSavedSearchDropDownVariant(true);
        }
      }
    } catch (error) {
      console.error('Visitor experiment conduction error:', error);
    }
  };

  useEffect(() => {
    // Defer experiment lookups to reduce main-thread work during initial paint.
    const experimentTimer = setTimeout(() => {
      if (isPremiumUser) {
        runPremiumExperiment();
      } else {
        runVisitorExperiment();
      }
    }, 0);

    return () => clearTimeout(experimentTimer);
  }, [isPremiumUser, isDesktopView]);

  const searchForm = (
    <SearchListingContainer
      localization={localization}
      deviceType={props.deviceType}
      isPremiumUser={false}
      jobsData={jobCardData}
      queryParams={props.queryParams}
      jobFilters={jobCardData.jobFilters}
      selectedFilters={props.selectedFilters}
      isRemoteJobsPage={true}
      envPath={getENVPath().NEXT_PUBLIC_ROOT_URL}
      isAddStaticSearchList={isAddStaticSearchList}
      isBasealign={isMobileView && isLoggedIn && !props.isPremiumUser}
      isExpSavedSearchDropDown={isExpSavedSearchVariant}
    />
  );

  const softRegProps = softRegModalProps({
    config,
    jobCardData,
    isFromWizardPage,
    isMobileView: isMobileView,
    hiring_count: props.hiring_count,
    isExperiment: isMobileView && !props.isPremiumUser,
  });
  const jobSearchStepsProp = jobSearchStepsProps({
    isCloseAllowed: true,
    isLoggedIn: isLoggedIn,
    themeType: themeType,
    isCategoryPage: false,
    signupAndFind: localization.unlock_banner.signup_and_find,
    jobsData: jobCardData,
    categoryDetails: {},
    hiringCount: props.hiring_count,
    localization: localization,
    screenName: 'jobs by category',
  });

  // Add this near the other useEffect hooks in your CategoryPage component
  const BannerProps = {
    breadCrumbProps: breadCrumbProps,
    basePathRewrite: basePathRewrite,
    bannerImageSrc: 'category-image.webp',
    title: 'Remote Jobs',
    jobDescriptionPara: localization.remoteJobDescription,
  };

  const [savedJobsArray, setSavedJobsArray] = useState<number[]>([]);
  //    const [guid, setGuid] = useState<any>(getOrUpdateGUID()); // for event tracking
  const [guids, setGuid] = useState<any>(getOrUpdateGUID()); // for event tracking

  const router = useRouter();

  const updateSaveJobState = useCallback((jobId: number, status: boolean) => {
    setSavedJobsArray((prev) =>
      status
        ? prev.includes(jobId)
          ? prev
          : [...prev, jobId]
        : prev.filter((id) => id !== jobId)
    );
  }, []);
  const saveJobState = useMemo(
    () => ({
      savedJobsArray,
      updateSaveJobState,
    }),
    [savedJobsArray, updateSaveJobState]
  );
  const determineAccessStatus = useCallback(
    (jobDetails: any) => {
      if (isLoggedIn) {
        return props.isPremiumUser ? SearchType.Unlocked : SearchType.Locked;
      }
      return jobDetails?.isFreeJob ? SearchType.Unlocked : SearchType.Locked;
    },
    [isLoggedIn, props.isPremiumUser]
  );
  const fetchJobData = useCallback(
    async (jobID: string) => {
      if (!jobID) throw new Error('Job ID is required for tracking.');
      const jobDetailResp = await getJobDetailsV2(jobID);
      const jobDetails = jobDetailResp?.data;
      if (!jobDetails) throw new Error(`No job details found for ID: ${jobID}`);
      const jobIndex = getJobIndex(jobCardData?.jobs?.results, jobID);
      const guid = getGuidValue(setGuid);
      return { jobDetails, jobIndex, guid };
    },
    [jobCardData?.jobs?.results, setGuid]
  );
  const trackJobSearchResult = useCallback(
    async (action: string, jobID?: string, clickOption?: string) => {
      const { jobDetails, jobIndex, guid } = await fetchJobData(jobID!);
      const accessStatus = determineAccessStatus(jobDetails);
      const mergerdQueries = { ...queryParams, ...router.query };
      return jobSearchResultTrackEvent(
        action,
        getSearchType(),
        ViewType.Job_Post_Details,
        accessStatus,
        jobDetails,
        jobCardData,
        mergerdQueries,
        clickOption,
        jobIndex,
        guid
      );
    },
    [
      fetchJobData,
      determineAccessStatus,
      queryParams,
      router.query,
      jobCardData,
    ]
  );
  const categoryLinksData = {
    categorySectionTitle: 'Remote Jobs',
    categoriesList: CategoriesList,
    saveJobState: saveJobState,
    trackJobSearchResult: trackJobSearchResult,
  };
  const pillsIcons = [
    'star.png',
    'chart.png',
    'group.png',
    'thunder.png',
    'clock.png',
  ];
  useLandingPageTracking();
  const [showExperiment, setShowExperiment] = useState(userInteractExpId === 3);
  const rmcWizardRemoteTypeUpdate = useCallback(async () => {
    // Desktop baselined to winning variant (FJ-9903); mobile experiment unchanged.
    if (isDesktopView) {
      setShowExperiment(true);
      return;
    }
    try {
      const visitorId = await ensureVisitorId(20, 1000);

      if (!visitorId) return;

      const expID = RMCPortalExperiments.rmcWizardRemoteTypeUpdateMobile.id;

      const expVariant = getExperimentVariant(expID);
      if (userInteractExpId === 3 || expVariant === 3) {
        setShowExperiment(true);
      } else if (
        (userInteractExpId === 0 || expVariant === 0) &&
        !isPremiumUser
      ) {
        // Only run experiment if no variant is set and user is not premium
        if (visitorId) {
          const exptData = await ConductExperimentV3(
            visitorId,
            RMCPortalExperiments.rmcWizardRemoteTypeUpdateMobile,
            cookieHeader || ''
          );

          if (exptData?.data?.variant === 3) {
            setShowExperiment(true);
          }
        }
      }
    } catch (error) {
      console.error('Visitor experiment conduction error:', error);
    }
  }, [isDesktopView, isPremiumUser]);
  useEffect(() => {
    const experimentTimer = setTimeout(() => {
      rmcWizardRemoteTypeUpdate();
    }, 0);

    return () => clearTimeout(experimentTimer);
  }, [rmcWizardRemoteTypeUpdate]);
  return (
    <>
      <Head>
        {RemoteCategoriesMetaTags({
          categoryName: 'index',
          schemaDateModified: props.schemaDateModified,
          categorizedJobs: props.categorizedJobs,
        })}
        {!isLoggedIn && isSoftRegModal && !isSoftRegAlreadyShown && (
          <link
            rel="prefetch"
            href="/payment/scripts/rmc/sellPrefetchScript.js"
            as="script"
          />
        )}
        {!isMobileView && (
          <link
            rel="preload"
            href={blob_img_path + 'category-image.webp'}
            as="image"
          />
        )}
        {expBrowsingCategoryDetailsVariant === '3' &&
          pillsIcons.map((icon) => (
            <link
              key={icon}
              rel="preload"
              href={blob_img_path + `icons/${icon}`}
              as="image"
            />
          ))}
      </Head>
      <Script
        src={`${
          getENVPath().NEXT_PUBLIC_ASSET_URL
        }/ui-experimentation/cdn/experiment-sync.min.js`}
        strategy="afterInteractive"
      />
      <Script id="experiment-script" strategy="afterInteractive">
        {`
          window.fireExperimentEvent = ${fireExperimentEvent.toString()};
        `}
      </Script>
      {!isFromWizardPage && showFlexJobsDifferent && (
        <FlexJobDifferModal
          closeModal={() => closeFJDifferentModal(setShowFlexJobsDifferent)}
          localizeflexjobPopup={localizationWhyRMCJobs}
        />
      )}
      <JobSearchSteps jobSearchStepsProps={jobSearchStepsProp} />
      <RemoteJobsPage
        {...BannerProps}
        isLoggedIn={isLoggedIn}
        localization={localization}
        searchForm={searchForm}
        categoryData={props.categorizedJobs}
        categoryLinksData={categoryLinksData}
        themeType={themeType}
        deviceType={props.deviceType}
        isSoftRegModal={!isLoggedIn}
        softRegModalProps={softRegProps}
        isBasealign={isMobileView && !props.isPremiumUser}
        isUserInteracted={
          isUserInteractiveJobVariant !== null
            ? { variant: Number(isUserInteractiveJobVariant) }
            : undefined
        }
        trackJobSearchResult={trackJobSearchResult}
        isPremiumUser={props.isPremiumUser}
        assetUrl={getAbsoluteURL}
        expBrowsingCategoryDetailsVariant={browsingCategoryVariant} //exp browsing_CategoryHub
      />
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext,
  resolvedUrl = ''
) => {
  let { req, query, res } = context;
  let jobCardData: any = [];
  let categorizedJobs: any = [];
  const isSearchPage = resolvedUrl?.includes('searchPage');
  const commonSSRProps = await commonPropsForSSR(
    req,
    isSearchPage ? 'simple-search' : 'jobs_page'
  );

  // CDN props made before sanitization for search filters
  const { cookieHeader, cookies, isPremiumUser, deviceType, userId } =
    commonSSRProps;

  //exp browsing_CategoryHub
  const expBrowsingCategoryDetails = getCDNExptDetails(
    query,
    deviceType,
    CDN_EXPERIMENT_DETAILS.browsing_CategoryHub,
    cookieHeader
  );
  let selectedFilters = acceptOnlyFilterdKeys(query);
  query = mapQueryParams(query);
  let queryString: string = getFilterQueryString(query);
  let sortByPostedDate = false;
  let searchKeyword: string = getURLSearchParams(queryString, 'searchkeyword');
  const previousUrl = req.headers.referer || '/';
  const isFromWizardPage =
    previousUrl?.includes('job_wizard') || previousUrl?.includes('wizard');
  const setNoStoreHeaders = () => {
    res.setHeader(
      'Cache-Control',
      'private, max-age=0, no-cache, no-store, must-revalidate'
    );
    res.setHeader('Vary', 'Cookie, User-Agent');
  };

  const ejEndPoints = getEJendPoints();

  const apiEndpoints = {
    job_details: { ...ejEndPoints.job_details, callback: modifyJobFilters },
    hiring_count: ejEndPoints.hiring_count,
  };

  await modifyJobDetails(
    apiEndpoints.job_details,
    `search/${queryString.slice(0, -1)}`,
    {
      sortByPostedDate: true,
      Age: 14,
    }
  );

  categorizedJobs = await getFreeJobsByCategory(
    { size: '3', cookieHeader, req },
    remoteJobsList
  );
  const data = await apiCallList({ apiEndpoints, cookieHeader, req });
  let { job_details, hiring_count = { jobsCount: 0, companiesCount: 0 } } =
    data;

  if (!job_details?.jobs?.results?.length) {
    setNoStoreHeaders();
    job_details = { jobs: { results: [], totalPages: 1, resultPerPage: 0 } };
  }

  let result = apiEndpoints.job_details.callback(
    query,
    job_details,
    isPremiumUser
  );

  query = result.query;
  jobCardData = result.jobCardData;
  const localizationGenereicData = [getLocalizationAndConfig('*')];
  const [[localizationGenereic]] = await Promise.all<any>(
    localizationGenereicData
  );

  if (!searchKeyword) {
    sortByPostedDate = true;
  }

  let jobDetailsApiUrl = '';
  if (query.debug) {
    jobDetailsApiUrl = getJobDetailsApiUrl(
      `search${queryString.slice(0, -1)}`,
      cookieHeader,
      sortByPostedDate,
      !isSearchPage,
      req.headers
    );
  }
  //exp browsing_CategoryHub
  const getbrowsingCategoryExpVariant = Object.values(
    CDN_EXPERIMENT_DETAILS.browsing_CategoryHub
  ).includes(expBrowsingCategoryDetails.eID)
    ? expBrowsingCategoryDetails.vID
    : '';
  const schemaDateModified = new Date().toISOString();
  const exprmcWizardRemoteTypeUpdate = () => {
    // Desktop baselined to winning variant (FJ-9903); mobile experiment unchanged.
    if (deviceType === 'desktop') return 3;
    let expVarientData = 0;
    try {
      const expVariant = getExperimentVariant(
        RMCPortalExperiments.rmcWizardRemoteTypeUpdateMobile.id,
        cookieHeader
      );
      if (expVariant === 3) {
        expVarientData = expVariant;
      }
    } catch (error) {
      console.error('Visitor experiment conduction error:', error);
    }
    return expVarientData;
  };
  return {
    props: {
      ...commonSSRProps,
      fullwidth: true,
      jobCardData: jobCardData,
      categorizedJobs: categorizedJobs,
      selectedFilters,
      hiring_count,
      queryParams: query,
      isFromWizardPage,
      referer: req?.headers?.referer ?? '',
      userAgent: req?.headers['user-agent'] ?? '',
      jobDetailsApiUrl: jobDetailsApiUrl,
      isSearchPage: isSearchPage,
      localizationWhyRMCJobs: localizationGenereic['how_flexjob_different'],
      showAllDropFilters:
        cookies[_CONSTANTS.SET_SHOW_ALL_DROP_FILTERS] === 'true' ? true : false,
      cdnExptData: getCDNExptDetails(
        query,
        commonSSRProps.deviceType,
        CDN_EXPERIMENT_DETAILS.bundle_test_v1,
        commonSSRProps?.cookieHeader
      ),
      themeType: commonSSRProps?.themeType || 'graphite',
      cookieHeader: commonSSRProps?.cookieHeader || '',
      expBrowsingCategoryDetailsVariant: getbrowsingCategoryExpVariant, //exp browsing_CategoryHub
      schemaDateModified,
      userInteractExpId: exprmcWizardRemoteTypeUpdate(),
    },
  };
};
